import script from "./MyCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCompany.vue?vue&type=script&setup=true&lang=js"

import "./MyCompany.vue?vue&type=style&index=0&id=5731e2a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5731e2a1"]])

export default __exports__